/**
 * Layout values shared across the bulk booking screens (DEV-1215).
 */

/**
 * The Edit column, pinned to the right edge of a row table.
 *
 * Used by the wizard's review step and by the report's failures table. Edit is the only thing in
 * either table you can press, so it must stay reachable however far the columns scroll — the review
 * step scrolls a long way at seventeen columns, and the report's four fit on a desktop but not on a
 * narrow window.
 *
 * The background has to be OPAQUE. A sticky cell sits above the cells scrolling beneath it, and both
 * tables tint their rows with a semi-transparent wash, so inheriting that would let the passing
 * columns show through. Callers paint their own tint back on as an inset overlay, which also needs
 * `relative` on the cell — neither BasicTable.Cell nor this string sets it.
 */
export const STICKY_EDIT_CELL = "sticky right-0 z-10 w-24 bg-white shadow-[-6px_0_6px_-6px_rgba(0,0,0,0.12)]";

/** Pinned both ways, so it must clear the sticky header row AND the sticky column below it. */
export const STICKY_EDIT_HEADER = "sticky right-0 top-0 z-20 w-24 shadow-[-6px_0_6px_-6px_rgba(0,0,0,0.12)]";

/**
 * The Booking Detail column, shared by all three of the report's tables.
 *
 * There are three because the report shows a different one while the run is going, after it finishes,
 * and for the trips it created — and a row moves between them. Declared once because they were not
 * the same: this column was widened for the two-line detail in two places and left at 260px in the
 * others, so a row being re-checked rendered 120px narrower than the column holding it, and a retry
 * shrank the whole table and then grew it again when the run ended.
 */
export const DETAIL_COLUMN = "min-w-[380px]";

/**
 * How wide the import report is allowed to get, shared by its two hosts (DEV-1215).
 *
 * The report is one component with two frames around it — a page for whoever arrives from the
 * completion email, a modal for whoever presses View on the snackbar. They have to lay out the same,
 * and the failures table's own minimums (row number, a two-line booking detail, a reason, an Edit
 * button) are what set the number. Declared once so the two can't drift.
 *
 * `!` because the Modal atom's variant sets its own max-width and would otherwise win.
 */
export const REPORT_MAX_WIDTH = "!max-w-[1164px]";
